export const DISALLOWED_TERMS = [
  'bcaba',
  'bcba cert',
  'bcba-d',
  'caadc',
  'cac iii',
  'cadc',
  'cba',
  'cdac',
  'cdca',
  'cns',
  'coba',
  'csac i / csac ii',
  'hspp',
  'imft',
  'imft-s',
  'ladc',
  'lba',
  'lcadc',
  'lcadc',
  'lcdc',
  'lcmft',
  'lcmhc',
  'lcp',
  'lcpat',
  'lcpc',
  'lcpc',
  'lcsw',
  'lcsw-c',
  'licdc',
  'licdc-cs',
  'licsw',
  'limhp',
  'lisac',
  'lisw',
  'lisw-s',
  'lmac',
  'lmft',
  'lmhc',
  'lmhc',
  'lmhp',
  'lmsw',
  'lnp',
  'lp',
  'lpat',
  'lpc',
  'lpcc',
  'lpcc',
  'lpp',
  'lscsw',
  'lscsw',
  'lsw',
  'md',
  'prescriber',
  'np',
  'pcc-s',
  'plp',
  'plpc',
  'psyd / lp',
  'phd',
  'cp',
  'dr',
  'dr.',
  'nurse',
  'nurse practioner'
];

export const PROFANITY: string[] = [
  'anus',
  'anuses',
  'arse',
  'ass',
  'asses',
  'asshole',
  'bastard',
  'bitch',
  'bullshit',
  'bussies',
  'bussy',
  'butt',
  'butthole',
  'chink',
  'cholo',
  'cock',
  'coochie',
  'coolie',
  'cracker',
  'crap',
  'cunt',
  'damn',
  'deadass',
  'dickhead',
  'dilf',
  'douche',
  'dumb',
  'dyke',
  'fag',
  'fuck',
  'goddamn',
  'gook',
  'gringo',
  'guk',
  'homo',
  'jackoff',
  'jap',
  'jerk',
  'kill',
  'killer',
  'kkk',
  'kraut',
  'lesbo',
  'lezzie',
  'loser',
  'masturbate',
  'masturbat',
  'milf',
  'nasty',
  'nigger',
  'nympho',
  'oaf',
  'pedo',
  'penis',
  'piss',
  'porn',
  'prick',
  'pussies',
  'pussy',
  'queef',
  'queer',
  'reject',
  'retard',
  'tard',
  'sex',
  'sexy',
  'shit',
  'shiteater',
  'shitface',
  'shithead',
  'shithole',
  'shits',
  'shitting',
  'shitty',
  'spic',
  'squaw',
  'teat',
  'tit',
  'tits',
  'twat',
  'vag',
  'vagina',
  'wanker',
  'wap',
  'weeb',
  'weird',
  'weirdo',
  'weird',
  'wetback',
  'white trash',
  'whore',
  'wog',
  'wop',
  'xxx'
];
